import React from 'react';
import Wrapper from './style';
import { emptyBox } from '../../assets';

const Index = (props) => {
  const {
    className,
    desc = '',
    title = '',
    image,
    boldText,
    bottomComponent,
  } = props;
  const reg = new RegExp(`(${boldText})`, 'gi');
  const textParts = desc.split(reg);

  return (
    <Wrapper className={className ?? ''}>
      <div className="container_empty_results_wrapper">
        <div className="font-subtitle1_medium">{title}</div>
        <div className="font-paragraph component_empty_results_paragraph">
          {textParts.map((part) => {
            return part.match(reg) ? (
              <span className="font-paragraph_medium bold">{part}</span>
            ) : (
              part
            );
          })}
        </div>
        <img alt="empty results" src={image ?? emptyBox} />
        {bottomComponent}
      </div>
    </Wrapper>
  );
};

export default Index;
